module.exports = __webpack_public_path__ + "img/slider_home_02.5782feab.jpg";